import ArrowChevronRight from '@jda/lui-common-icon-library/ui/ArrowChevronRight';
import { AppBar, Breadcrumbs, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { matchPath, Route, Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(1)
    }
  },
  link: {
    color: 'inherit',
    textDecoration: 'none'
  },
  end: {
    fontWeight: ('400 !important' as unknown) as 400
  }
}));

const staticRoutesMap: { [key: string]: any } = {
  '/dashboard': 'Dashboard',
  '/participant': 'Participants',
  '/service': 'Services',
  '/audit': 'Audit',
  '/errorDiagnosis': 'Error Diagnosis',
  '/notifications': 'Notifications',
  '/users': 'Users',
  '/certification': 'Certifications'
  // '/faq': 'FAQ'
};

const dynamicRoutesMap: { [key: string]: string } = {
  '/participant/:id': '{{id}}',
  '/participant/:id/service': 'Service',
  '/participant/:id/authenticate': 'Authenticate',
  '/participant/:id/service/:work': '{{work}}',
  '/service/:id': '{{id}}',
  '/service/:id/customers': 'Customers',
  '/service/:id/providers': 'Providers'
};
const paramRegx = /{{([a-zA-Z_$][a-zA-Z0-9_$]*)}}/;

const replaceParams = (names: string, params: any) => {
  let match = paramRegx.exec(names);
  while (match) {
    names = names.replace(match[0], params[match[1]]?.replace(/%20/g, ' '));
    match = paramRegx.exec(names);
  }
  return names;
};

const getBreadCrumbName = (url: string) => {
  let names = staticRoutesMap[url];
  if (!names) {
    Object.keys(dynamicRoutesMap).forEach(pathname => {
      const pathMatchResult = matchPath(url, {
        path: pathname,
        exact: true,
        strict: true
      });
      if (pathMatchResult) {
        const { params } = pathMatchResult;
        names = dynamicRoutesMap[pathname];
        names = replaceParams(names, params);
      }
      return pathMatchResult;
    });
  }
  return names;
};

const BreadCrumb = () => {
  const classes = useStyles();
  let pathNames = window?.location?.pathname;
  return (
    <Route>
      {({ location }) => {
        const pathnames = pathNames.split('/').filter(x => x);
        return (
          <AppBar position="static" color="primary">
            <Toolbar variant="dense" className={classes.root}>
              <Breadcrumbs separator={<ArrowChevronRight />} aria-label="breadcrumb">
                <Link className={classes.link} to="/">
                  Home
                </Link>
                {pathnames.map((value, index) => {
                  const last = index === pathnames.length - 1;
                  const to = `/${pathnames.slice(0, index + 1).join('/')}`;

                  return last ? (
                    <Typography color="textPrimary" className={classes.end} key={to}>
                      {getBreadCrumbName(to)}
                    </Typography>
                  ) : (
                    <Link className={classes.link} to={to} key={to}>
                      {getBreadCrumbName(to)}
                    </Link>
                  );
                })}
              </Breadcrumbs>
            </Toolbar>
          </AppBar>
        );
      }}
    </Route>
  );
};

export default BreadCrumb;
